import { all, takeLatest } from 'redux-saga/effects';

import { getDeepLink } from './getDeepLink';
import * as actionTypes from '../actionTypes';

export default function* watchDeepLink() {
    yield all([takeLatest(actionTypes.GET_DEEP_LINK_REQUEST, getDeepLink)]);
}
